import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PaginationService {
     #currentPageSubject: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);

    #warningSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

    currentPage?: number;

    currentPage$: Observable<number | null> = this.#currentPageSubject.asObservable();

    warning$: Observable<string | null> = this.#warningSubject.asObservable();

    setCurrentPage(page: number) {
        this.currentPage = page;
        this.#currentPageSubject.next(page);
    }

    triggerWarning(message: string): void {
        this.#warningSubject.next(message);
    }

    clearWarning(): void {
        this.#warningSubject.next(null);
    }
}
